import styled from "styled-components";

/** A block of the page; edge to edge on phones. */
export const Card = styled.section`
    border: 1px solid #e8edf4;
    border-radius: 14px;
    background: #fff;
    padding: 14px 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    min-width: 0;
    @media (max-width: 600px) {
        border-radius: 0;
        border-left: none;
        border-right: none;
        box-shadow: none;
        padding: 14px 16px;
    }
`;

export const CardTitle = styled.h2`
    margin: 0 0 10px;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #64748b;
`;
